/* Project Import will be here */
import { getSmartListApi, addSmartListApi } from 'services/smartList';
import { errorToast, getErrorObject, getSuccessObject } from 'utilities/utils';
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
import { GAAddToSmartList } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

export const types = {
    SMART_LIST_TEMPLATE_REQUEST: "smartListTemplate/smartListTemplateRequest",
    SMART_LIST_TEMPLATE_SUCCESS: "smartListTemplate/smartListTemplateSuccess",
    SMART_LIST_TEMPLATE_FAILURE: "smartListTemplate/smartListTemplateFailure",
    ADD_NEW_TEMPLATE_NAME: "smartListTemplate/addNewTemplateName"
};

let initialState = {
    isLoading: false,
    templateList: [],
    newTemplateName: "",
    error: null
};

export const smartListTemplate = (state = initialState, action) => {
    switch (action.type) {
        case types.SMART_LIST_TEMPLATE_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.SMART_LIST_TEMPLATE_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.SMART_LIST_TEMPLATE_FAILURE:
            return {
                ...state,
                isLoading: false,
                templateList: [],
                error: action.payload.error
            };
        case types.ADD_NEW_TEMPLATE_NAME:
            return {
                ...state,
                newTemplateName: action.payload.name
            };
        default:
            return state;
    }
};

/* Get all smart list template list */
export const getSmartListTemplateList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SMART_LIST_TEMPLATE_REQUEST });
        try {
            const response = await getSmartListApi();
            dispatch({
                type: types.SMART_LIST_TEMPLATE_SUCCESS,
                payload: { templateList: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.SMART_LIST_TEMPLATE_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* On change new template name */
export const onChangeNewTemplateName = (name) => {
    return async (dispatch) => {
        dispatch({ type: types.ADD_NEW_TEMPLATE_NAME, payload: { name } });
    }
}

/* Save the order products to smart list */
export const saveSmartListTemplate = () => {
    return async (dispatch, getState) => {
        try {
            let arr = [], products = getState().cart["data"] || [];
            Object.keys(products).forEach((eachProduct, index) => {
                arr.push({
                    DistributorId: products[eachProduct]["DistributorId"],
                    PId: products[eachProduct]["ProductId"],
                    PrincipalId: products[eachProduct]["PrincipalId"],
                    Qty: products[eachProduct]["Qty"],
                    UomId: products[eachProduct]["UomId"],
                });
            })
            const requestObject = {
                TemplateDetail: arr,
                TemplateName: getState().smartListTemplate.newTemplateName
            };

            const response = await addSmartListApi(requestObject);

            const { successCode } = getSuccessObject(response);
            const messagePath = successCode !== "" ? `common.alerts.success.${successCode}` : `common.alerts.success.smartListSaveSuccess`;
            dispatch(showMsgFromJson(messagePath, Constants.SUCCESS));

            /* GA - Track add to smart list event */
            if (window.isEnableGA)
                GAAddToSmartList(requestObject.TemplateName);
        }
        catch (error) {
            /* Extract the error message and error code from the response object */
            const { message, errorCode } = getErrorObject(error);

            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
}